// extracted by mini-css-extract-plugin
module.exports = {"companyDetails":"companyDetails-1T0aGH9Wb_lH4fmGdNwE0d","card":"card-Z5IMOFa92o1ZPgSiHGstz"};